/**
 * SKU utility functions for device SKU tracking
 * SKUs are now dynamically managed in DynamoDB
 */

// Get display label for SKU
export const getSKUDisplayLabel = (
  skuName: string | null | undefined
): string => {
  // Empty/null = no SKU assigned
  if (!skuName) return "";

  // Explicitly set to Legacy

  if (skuName === "LEGACY") return "Legacy";

  // Return the SKU name as-is (stored from DynamoDB)
  return skuName;
};

// Check if device is explicitly marked as Legacy
export const isLegacySKU = (skuName: string | null | undefined): boolean => {
  return skuName === "LEGACY";
};

// Check if SKU is explicitly set (not null/undefined/empty)
export const isSKUAssigned = (skuName: string | null | undefined): boolean => {
  return !!skuName && skuName.trim() !== "";
};
